import React from "react";

const QuestionsAndChoicesIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66.699"
      height="42.963"
      viewBox="0 0 66.699 42.963"
    >
      <g id="db28" transform="translate(0 0)">
        <path
          id="Path_1248"
          data-name="Path 1248"
          d="M120.1,68.6a4.894,4.894,0,1,1-5.061,4.891A4.989,4.989,0,0,1,120.1,68.6m0-3.9a8.8,8.8,0,1,0,9.1,8.791,8.959,8.959,0,0,0-9.1-8.791Z"
          transform="translate(-86.745 -64.7)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1249"
          data-name="Path 1249"
          d="M131.111,188.088l-8.256-8.588-8.256,8.588,1.469,1.33,4.758-4.959v12.127h4.058v-12.1l4.758,4.936Z"
          transform="translate(-89.506 -153.623)"
          fill={fill ? fill : "#a07eff"}
        />
        <g
          id="Group_1186"
          data-name="Group 1186"
          transform="translate(48.509 0.067)"
        >
          <ellipse
            id="Ellipse_349"
            data-name="Ellipse 349"
            cx="9.095"
            cy="8.791"
            rx="9.095"
            ry="8.791"
            transform="translate(0 0)"
            fill={fill ? fill : "#a07eff"}
          />
        </g>
        <g
          id="Group_1187"
          data-name="Group 1187"
          transform="translate(0 0.067)"
        >
          <ellipse
            id="Ellipse_350"
            data-name="Ellipse 350"
            cx="9.095"
            cy="8.791"
            rx="9.095"
            ry="8.791"
            transform="translate(0 0)"
            fill={fill ? fill : "#a07eff"}
          />
        </g>
      </g>
    </svg>
  );
};

export default QuestionsAndChoicesIcon;
